import React from 'react'

// query
import { useQuery, useMutation } from '@apollo/client'
import { GET_EQUIPMENT_BY_ID_WITH_QUANTITY } from '../../../../../graphql/equipment/equipment.queries'
import { REFRESH_EQUIPMENT_QUANTITY } from '../../../../../graphql/equipment/equipment.mutations'

// mui
import { Box, Stack } from '@mui/system'
import SyncIcon from '@mui/icons-material/Sync';
import { IconButton } from '@mui/material';

export default function EquipmentQuantity({ id }) {
    let [refreshEquipmentQuantity, ] = useMutation(REFRESH_EQUIPMENT_QUANTITY)
    let equipment = {}

    const { loading, error, data } = useQuery(GET_EQUIPMENT_BY_ID_WITH_QUANTITY, {
        variables: { id }
    })

    if(loading) {
        return <div></div>
    }

    if(data && data.equipment){
        equipment = {...data.equipment}
    }

    const handleSync = () => {
        refreshEquipmentQuantity({ variables: {id}, refetchQueries: [GET_EQUIPMENT_BY_ID_WITH_QUANTITY]}).catch(e => {
            console.error(e)
        })
    }

    return (<Box>
        <Stack direction="row" spacing={1}>
            
                Quantity: {equipment.quantity}
            

            <IconButton color="primary" size="small" onClick={handleSync}>
                <SyncIcon />
            </IconButton>
        </Stack>
        </Box>)
}